var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15C1 18.0653 1.16555 20.4603 1.58286 22.338C1.99765 24.2044 2.64775 25.4979 3.57492 26.4251C4.50209 27.3523 5.79561 28.0023 7.66199 28.4171C9.53972 28.8344 11.9347 29 15 29C18.0653 29 20.4603 28.8344 22.338 28.4171C24.2044 28.0023 25.4979 27.3523 26.4251 26.4251C27.3523 25.4979 28.0023 24.2044 28.4171 22.338C28.8344 20.4603 29 18.0653 29 15C29 11.9347 28.8344 9.53972 28.4171 7.66199C28.0023 5.79561 27.3523 4.50209 26.4251 3.57492C25.4979 2.64775 24.2044 1.99765 22.338 1.58286C20.4603 1.16555 18.0653 1 15 1C11.9347 1 9.53972 1.16555 7.66199 1.58286C5.79561 1.99765 4.50209 2.64775 3.57492 3.57492C2.64775 4.50209 1.99765 5.79561 1.58286 7.66199C1.16555 9.53972 1 11.9347 1 15Z",
    stroke: "#0FB515",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9471 10.2273L16.1494 7.91787C16.6555 7.38722 17.5057 7.35807 18.0486 7.85275L22.0725 11.5199C22.6154 12.0146 22.6452 12.8458 22.1392 13.3764L19.7727 15.8579M13.9471 10.2273L7.86085 16.6096C7.60791 16.8748 7.47838 17.2305 7.50295 17.5923L7.75292 21.2734C7.79992 21.9655 8.38926 22.5026 9.09879 22.5L12.8728 22.486C13.2438 22.4846 13.5976 22.3334 13.8506 22.0681L19.7727 15.8579M13.9471 10.2273L19.7727 15.8579",
    stroke: "#0FB515",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBtn);
export default __webpack_public_path__ + "static/media/EditBtn.6271adaaa761752bd2683ada0bf702b0.svg";
export { ForwardRef as ReactComponent };